/**
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import ScaleUtil from './ScaleUtil';
import { ProgressBar } from 'react-bootstrap';

export default class ScaleRange extends Component {
  render() {
    let value = ScaleUtil.toKg(this.props.value);
    const min = ScaleUtil.toKg(this.props.min);
    const max = ScaleUtil.toKg(this.props.max);
    value = value < min ? min : value;
    return <ProgressBar now={value} min={min} max={max} />;
  }
}
